import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TransferInstallationFormData } from '@store';
import { FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-description-form',
  templateUrl: './description-form.component.html',
  styleUrls: ['./description-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DescriptionFormComponent implements OnInit, OnDestroy {
  @Input() formData: TransferInstallationFormData;
  @Input() isMandatory: boolean;
  @Output() descriptionChange: EventEmitter<{
    isValid: boolean;
    description: string;
  }> = new EventEmitter<{
    isValid: boolean;
    description: string;
  }>();

  descriptionFormControl: FormControl<string>;

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor() {}

  ngOnInit(): void {
    this.descriptionFormControl = new FormControl<string>(
      this.formData.description,
      this.isMandatory
        ? [Validators.required, Validators.minLength(3), Validators.maxLength(100)]
        : [Validators.minLength(3), Validators.maxLength(100)]
    );

    this.descriptionFormControl.valueChanges
      .pipe(distinctUntilChanged(), takeUntil(this.ngUnsubscribe))
      .subscribe((value) => {
        this.descriptionChange.emit({
          isValid: this.descriptionFormControl.valid,
          description: value,
        });
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
